/* Native megamenu spike — 2026-04-26
   Desktop: hover-intent (150ms in / 200ms out) + keyboard nav + ARIA.
   Mobile: drill-down stack with focus management. */
(function () {
  'use strict';
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // Touch-only devices have no hover capability — top-level click then needs to
  // BOTH expose the dropdown AND let users reach the parent collection. Pattern:
  // first tap opens, second tap on already-open trigger navigates. On hover-
  // capable devices (desktop mouse), hover handles the open and click goes
  // straight to navigation.
  var IS_TOUCH_ONLY = !!(window.matchMedia && window.matchMedia('(hover: none) and (pointer: coarse)').matches);
  var HOVER_OPEN_MS = REDUCED ? 0 : 150;
  var HOVER_CLOSE_MS = REDUCED ? 0 : 200;

  // ---------- Desktop hover-intent ----------
  function initDesktop(root) {
    if (!root) return;
    var triggers = root.querySelectorAll('.mm-toplevel__btn[data-mm-trigger]');
    var openTimer = null;
    var closeTimer = null;
    var current = null;

    function panelFor(trigger) {
      var id = trigger.getAttribute('aria-controls');
      return id ? document.getElementById(id) : null;
    }
    function openPanel(trigger) {
      clearTimeout(closeTimer);
      if (current && current !== trigger) closePanel(current, true);
      var panel = panelFor(trigger);
      if (!panel) return;
      var inner = panel.querySelector('.mm-panel');
      if (inner) inner.removeAttribute('hidden');
      trigger.setAttribute('aria-expanded', 'true');
      current = trigger;
      if (window.__mmAnnounce) {
        var label = (trigger.textContent || '').trim();
        var count = panel.querySelectorAll('.mm-col__links a').length;
        window.__mmAnnounce(label + ' submenu opened, ' + count + ' items');
      }
    }
    function closePanel(trigger, immediate) {
      var panel = panelFor(trigger);
      if (!panel) return;
      var doClose = function () {
        var inner = panel.querySelector('.mm-panel');
        if (inner) inner.setAttribute('hidden', '');
        trigger.setAttribute('aria-expanded', 'false');
        if (current === trigger) current = null;
      };
      if (immediate) doClose();
      else closeTimer = setTimeout(doClose, HOVER_CLOSE_MS);
    }

    // Helpers for keyboard nav (WAI-ARIA menubar pattern)
    var triggersArr = Array.prototype.slice.call(triggers);
    function focusTrigger(idx) {
      var n = triggersArr.length;
      var i = ((idx % n) + n) % n;
      triggersArr[i].focus();
      return triggersArr[i];
    }
    function panelMenuItems(trigger) {
      var panel = panelFor(trigger);
      return panel ? Array.prototype.slice.call(panel.querySelectorAll('.mm-col__links a')) : [];
    }
    function openAndFocus(trigger, which) {
      openPanel(trigger);
      var items = panelMenuItems(trigger);
      if (!items.length) return;
      var target = which === 'last' ? items[items.length - 1] : items[0];
      target.focus();
    }

    triggers.forEach(function (trigger, idx) {
      var li = trigger.closest('.mm-toplevel__item');
      var panel = panelFor(trigger);

      // Hover intent
      li.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer); clearTimeout(openTimer);
        openTimer = setTimeout(function () { openPanel(trigger); }, HOVER_OPEN_MS);
      });
      li.addEventListener('mouseleave', function () {
        clearTimeout(openTimer);
        closePanel(trigger);
      });
      if (panel) {
        panel.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
        panel.addEventListener('mouseleave', function () { closePanel(trigger); });
      }

      // Click behaviour:
      //   - Trigger has no URL (e.g. "DEALS" with `mm-toplevel__btn--no-link`)
      //     OR the fallback link is missing → toggle the dropdown only.
      //   - Touch-only + dropdown closed → first tap opens the dropdown
      //     without navigating; a second tap then navigates.
      //   - All other cases (desktop mouse click; touch tap on already-open
      //     trigger) → navigate to the parent URL captured on the
      //     mm-toplevel__link-fallback anchor.
      //   Modifier-key new-tab opening (Ctrl/Cmd/middle-click) routes the
      //   synthetic click through the fallback `<a>` so the browser handles
      //   it natively.
      trigger.addEventListener('click', function (e) {
        var noLink = trigger.classList.contains('mm-toplevel__btn--no-link');
        var fallback = li.querySelector('.mm-toplevel__link-fallback');
        var url = fallback ? fallback.getAttribute('href') : null;
        var open = trigger.getAttribute('aria-expanded') === 'true';

        if (noLink || !url) {
          e.preventDefault();
          if (open) closePanel(trigger, true); else openPanel(trigger);
          return;
        }

        if (IS_TOUCH_ONLY && !open) {
          e.preventDefault();
          openPanel(trigger);
          return;
        }

        // Has URL + (desktop OR touch with panel already open) → navigate.
        e.preventDefault();
        if (e.ctrlKey || e.metaKey || e.button === 1) {
          window.open(url, '_blank');
        } else {
          window.location.href = url;
        }
      });

      // Top-level trigger keyboard pattern (menubar)
      trigger.addEventListener('keydown', function (e) {
        switch (e.key) {
          case 'ArrowRight':
            e.preventDefault();
            if (current) closePanel(current, true);
            focusTrigger(idx + 1);
            break;
          case 'ArrowLeft':
            e.preventDefault();
            if (current) closePanel(current, true);
            focusTrigger(idx - 1);
            break;
          case 'ArrowDown':
          case 'Enter':
          case ' ':
            e.preventDefault();
            openAndFocus(trigger, 'first');
            break;
          case 'ArrowUp':
            e.preventDefault();
            openAndFocus(trigger, 'last');
            break;
          case 'Home':
            e.preventDefault();
            if (current) closePanel(current, true);
            focusTrigger(0);
            break;
          case 'End':
            e.preventDefault();
            if (current) closePanel(current, true);
            focusTrigger(triggersArr.length - 1);
            break;
          case 'Escape':
            if (trigger.getAttribute('aria-expanded') === 'true') {
              closePanel(trigger, true);
            }
            break;
        }
      });

      // Submenu keyboard pattern: when focus is inside a panel, arrow keys navigate links
      if (panel) {
        panel.addEventListener('keydown', function (e) {
          var items = panelMenuItems(trigger);
          if (!items.length) return;
          var pos = items.indexOf(document.activeElement);
          switch (e.key) {
            case 'ArrowDown':
              e.preventDefault();
              items[(pos + 1 + items.length) % items.length].focus();
              break;
            case 'ArrowUp':
              e.preventDefault();
              items[(pos - 1 + items.length) % items.length].focus();
              break;
            case 'Home':
              e.preventDefault();
              items[0].focus();
              break;
            case 'End':
              e.preventDefault();
              items[items.length - 1].focus();
              break;
            case 'ArrowRight':
              e.preventDefault();
              closePanel(trigger, true);
              var next = focusTrigger(idx + 1);
              openAndFocus(next, 'first');
              break;
            case 'ArrowLeft':
              e.preventDefault();
              closePanel(trigger, true);
              var prev = focusTrigger(idx - 1);
              openAndFocus(prev, 'first');
              break;
            case 'Escape':
              e.preventDefault();
              closePanel(trigger, true);
              trigger.focus();
              break;
            case 'Tab':
              // Let Tab move focus naturally; close the panel so it doesn't linger.
              closePanel(trigger, true);
              break;
          }
        });
      }
    });

    // Outside click closes any open panel.
    // Scoped to .mm-toplevel__item (the <li> containing both the trigger
    // <button> and the dropdown <div id="mm-panel-N">) rather than the
    // wider menu root, so taps on other header elements (logo, search,
    // cart icon) also dismiss the panel. The trigger's own click handler
    // toggles when its <li> is the target — it doesn't conflict with this
    // listener because that handler returns early or navigates, and the
    // closePanel(current, true) here is a no-op if `current` was already
    // closed by the trigger's own click.
    document.addEventListener('click', function (e) {
      if (!current) return;
      if (!e.target.closest('.mm-toplevel__item')) closePanel(current, true);
    });

    // Drawer (cart/search) opens programmatically (e.g. add-to-cart auto-open)
    // bypass the click path. The theme toggles js-drawer-open* on
    // document.documentElement (not body — see theme.js line 4734-4735), so we
    // observe the html element. Mega panel z-index 50 sits above drawer 30;
    // force-close any open panel when a drawer opens.
    var htmlClassObserver = new MutationObserver(function () {
      if (!current) return;
      var html = document.documentElement;
      if (html.classList.contains('js-drawer-open') ||
          html.classList.contains('js-drawer-open--search')) {
        closePanel(current, true);
      }
    });
    htmlClassObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  }

  // ---------- Mobile drill-down ----------
  function initMobile(root) {
    if (!root) return;
    var openers = root.querySelectorAll('[data-mm-mobile-open]');
    var backers = root.querySelectorAll('[data-mm-mobile-back]');
    var levels = {};
    root.querySelectorAll('[data-mm-level]').forEach(function (l) {
      levels[l.getAttribute('data-mm-level')] = l;
    });
    var stack = ['root'];

    function clearLoadingState() {
      root.querySelectorAll('.mm-loading').forEach(function (el) {
        el.classList.remove('mm-loading');
      });
    }

    function show(name) {
      // Clear any stale tap-loading state on every level transition. A user
      // tapping a link, returning to the page, then re-opening the drawer
      // could otherwise see a still-pulsing-orange item from earlier.
      clearLoadingState();
      Object.keys(levels).forEach(function (n) {
        var el = levels[n];
        if (n === name) {
          el.removeAttribute('hidden');
          el.setAttribute('aria-hidden', 'false');
          el.setAttribute('data-mm-active', 'true');
        } else {
          // Restore inert state on deactivated levels — CSS hides visually via
          // transform, but a screen reader still traverses content unless we
          // re-add aria-hidden. Don't set the `hidden` attribute on root (it
          // would break the slide-out CSS transform); SR is excluded via
          // aria-hidden only. Drill-down levels get both for safety.
          el.removeAttribute('data-mm-active');
          el.setAttribute('aria-hidden', 'true');
          if (n !== 'root') el.setAttribute('hidden', '');
        }
      });
      root.setAttribute('data-active', name);
      // Move focus to first focusable child of the new level
      var focusTarget = levels[name].querySelector('button, a, [tabindex]:not([tabindex="-1"])');
      if (focusTarget) focusTarget.focus({ preventScroll: false });
      // Announce the level title for screen readers
      if (window.__mmAnnounce) {
        var title = levels[name].querySelector('.mm-mobile__title');
        if (title) window.__mmAnnounce(title.textContent.trim() + ' menu');
        else if (name === 'root') window.__mmAnnounce('Main menu');
      }
    }

    openers.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = btn.getAttribute('data-mm-mobile-open');
        if (!levels[target]) return;
        stack.push(target);
        show(target);
      });
    });
    backers.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (stack.length <= 1) return;
        stack.pop();
        show(stack[stack.length - 1]);
      });
    });

    // Initial state
    Object.keys(levels).forEach(function (n) {
      if (n !== 'root') {
        levels[n].setAttribute('hidden', '');
        levels[n].setAttribute('aria-hidden', 'true');
      }
    });
    root.setAttribute('data-active', 'root');

    // Loading-state feedback: when a navigating link is clicked, mark it
    // with .mm-loading so CSS turns it orange until the page navigates away.
    // Helps customers know their tap registered.
    //
    // We only listen to `click`, NOT `pointerdown`/`touchstart`. On touch
    // screens, pointerdown fires at the start of every touch including
    // scroll gestures — a finger brushing a link mid-scroll-through the
    // brand list would otherwise leave a false orange-pulsing state on
    // that link. `click` only fires on a real tap (no scroll), so it's
    // the right signal. Capture phase bypasses any drawer-close handlers
    // in the theme that might stopPropagation on bubble. Skipped for
    // modifier-clicks (cmd/ctrl/shift/alt — open in new tab, no current
    // page navigation, would leave a stuck state).
    function markLoading(e) {
      var link = e.target.closest('a.mm-mobile__leaf, a.mm-mobile__col-head');
      if (!link) return;
      if (link.target === '_blank') return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      // Single-selection: clear any previously-tapped link's loading state
      // so only the most-recently-tapped link glows orange. Without this,
      // repeated taps before navigation completes leave multiple items
      // stuck in the orange pulsing state (UAT 2026-05-27).
      clearLoadingState();
      link.classList.add('mm-loading');
    }
    root.addEventListener('click', markLoading, true);

    // Clear stale loading state in three additional scenarios:
    // 1. bfcache restore (navigating back to a page that had a tapped link)
    // 2. Drawer reopened — the theme adds js-drawer-open to documentElement;
    //    on transition false→true, clear so the user always sees a fresh menu
    // 3. Initial init — paranoia for any state surviving a JS reinit
    window.addEventListener('pageshow', clearLoadingState);
    var drawerOpenObserver = new MutationObserver(function () {
      if (document.documentElement.classList.contains('js-drawer-open')) {
        clearLoadingState();
      }
    });
    drawerOpenObserver.observe(document.documentElement, {
      attributes: true, attributeFilter: ['class']
    });
    clearLoadingState();

    // Reset to root level every time the NavDrawer opens fresh. Closing the
    // drawer with the × and reopening it must feel like opening a fresh menu,
    // not resuming the drilled-down position from the previous session
    // (UAT 2026-05-27). Scoped to #NavDrawer specifically — js-drawer-open
    // on documentElement is shared across cart/search drawers and resetting
    // the mobile menu when those open would be wasteful and could steal focus.
    var navDrawer = document.getElementById('NavDrawer');
    if (navDrawer) {
      var resetOnOpen = new MutationObserver(function () {
        if (!navDrawer.classList.contains('drawer--is-open')) return;
        if (stack.length === 1 && stack[0] === 'root') return;
        stack = ['root'];
        show('root');
      });
      resetOnOpen.observe(navDrawer, { attributes: true, attributeFilter: ['class'] });
    }
  }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else { fn(); }
  }

  // Visually-hidden aria-live region for transition announcements
  function ensureLiveRegion() {
    var live = document.getElementById('mm-live');
    if (live) return live;
    live = document.createElement('div');
    live.id = 'mm-live';
    live.setAttribute('aria-live', 'polite');
    live.setAttribute('aria-atomic', 'true');
    live.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);clip-path:inset(50%);white-space:nowrap;';
    document.body.appendChild(live);
    return live;
  }
  function announce(msg) {
    var live = ensureLiveRegion();
    // Force re-announcement when same text fires twice in a row
    live.textContent = '';
    setTimeout(function () { live.textContent = msg; }, 30);
  }

  ready(function () {
    initDesktop(document.querySelector('[data-mm-root]'));
    initMobile(document.querySelector('[data-mm-mobile]'));
  });

  // Expose for the mobile drill-down to use
  window.__mmAnnounce = announce;
})();
